import type { RefObject } from 'react';
import { useEffect } from 'react';

/**
 * 指定された行IDへスクロールするフック
 *
 * @param scrollToRowId - スクロール対象の行ID
 * @param tableRef - テーブル要素への参照
 */
export const useScrollToRow = (
  scrollToRowId: string | null | undefined,
  tableRef: RefObject<HTMLTableElement | null>,
) => {
  useEffect(() => {
    if (!scrollToRowId || !tableRef.current) return;

    // data-row-id属性で該当行を検索
    const targetRow = tableRef.current.querySelector(`[data-row-id="${scrollToRowId}"]`);
    if (targetRow) {
      // inline: 'nearest'でX軸のスクロールを防ぐ
      targetRow.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }, [scrollToRowId, tableRef]);
};
